export const requiredValidateEmail = (value: string): string | undefined => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!value) {
    return "Email is required.";
  }
  if (!emailRegex.test(value)) {
    return "Invalid email address.";
  }
  return undefined;
};

export const requiredValidatePhoneNumber = (value: string): string | undefined => {
  const phoneNumberPattern = /^\d{10}$/;
  if (!value) {
    return "Phone number is required.";
  }
  if (!phoneNumberPattern.test(value)) {
    return "Phone number must be a 10-digit number.";
  }
  return undefined;
};

export const validateEmail = (value: string): string | undefined => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (value && !emailRegex.test(value)) {
    return "Invalid email address.";
  }
  return undefined;
};

// export const validatePhoneNumber = (value: string): string | undefined => {
//   const phoneNumberPattern = /^\d{10}$/;
//   if (value && !phoneNumberPattern.test(value)) {
//     return "Phone number must be a 10-digit number.";
//   }
//   return undefined;
// };

export const validatePhoneNumber = (value: string): string | undefined => {
  const strippedValue = value.replace(/-/g, ""); // Remove dashes for validation
  const phoneNumberPattern = /^\d{10}$/;
  if (strippedValue && !phoneNumberPattern.test(strippedValue)) {
    return "Phone number must be a 10-digit number.";
  }
  return undefined;
};

// export const formatPhoneNumberForDisplay = (value: string): string => {
//   const strippedValue = value.replace(/\D/g, ""); // Remove all non-digit characters
//   const match = strippedValue.match(/^(\d{3})(\d{3})(\d{4})$/);
//   return match ? `${match[1]}-${match[2]}-${match[3]}` : value;
// };

export const formatPhoneNumberForDisplay = (value: string | null | undefined): string => {
  if (!value) {
    return ''; // Return an empty string or some default value if the input is null or undefined
  }

  const strippedValue = value.replace(/\D/g, ""); // Remove all non-digit characters
  const match = strippedValue.match(/^(\d{3})(\d{3})(\d{4})$/);
  return match ? `${match[1]}-${match[2]}-${match[3]}` : value;
};

export const formatPhoneNumberForDisplaySpace = (value: string | null | undefined): string => {
  if (!value) {
    return ''; // Return an empty string or some default value if the input is null or undefined
  }

  const strippedValue = value.replace(/\D/g, ""); // Remove all non-digit characters
  const match = strippedValue.match(/^(\d{3})(\d{3})(\d{4})$/);
  return match ? `${match[1]}${" "}${match[2]}${" "}${match[3]}` : value;
};
